import { render } from "./AccommodationItemList.vue?vue&type=template&id=6eff9f5c&scoped=true"
import script from "./AccommodationItemList.vue?vue&type=script&lang=js"
export * from "./AccommodationItemList.vue?vue&type=script&lang=js"

import "./AccommodationItemList.vue?vue&type=style&index=0&id=6eff9f5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eff9f5c"]])

export default __exports__